import { render, staticRenderFns } from "./TablaReportes.vue?vue&type=template&id=6469d0ee"
import script from "./TablaReportes.vue?vue&type=script&lang=js"
export * from "./TablaReportes.vue?vue&type=script&lang=js"
import style0 from "./TablaReportes.vue?vue&type=style&index=0&id=6469d0ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
